import * as React from 'react';
import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 378 378"
    fill="none"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m225.456 111.859 63.712 113.243c15.688 27.882-4.455 62.353-36.457 62.353H125.307c-32.002 0-52.145-34.45-36.458-62.353l63.713-113.243c15.959-28.446 56.893-28.446 72.894 0ZM189 191.677v-38.382"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M188.981 234.013c-1.046 0-1.904.857-1.883 1.903a1.91 1.91 0 0 0 1.903 1.904 1.893 1.893 0 0 0 1.883-1.904 1.897 1.897 0 0 0-1.903-1.903Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M314.5 377.25h-251C28.841 377.25.75 349.159.75 314.5v-251C.75 28.841 28.841.75 63.5.75h251c34.659 0 62.75 28.091 62.75 62.75v251c0 34.659-28.091 62.75-62.75 62.75Z"
    />
  </svg>
);
export default SvgComponent;
